import type { SessionUser } from '@/api/profile/types';
import { API_ROOT_URL } from '@/lib/constants/api';
import { apiFetch } from '@/lib/utils/apiFetch';
import type { PreferenceItem, UpdateProfileBody } from './types';

export async function putMe(body: UpdateProfileBody): Promise<SessionUser> {
  return apiFetch<SessionUser>(
    '/api/users/me',
    { method: 'PUT', body: JSON.stringify(body) },
    API_ROOT_URL,
  );
}

export async function patchPreferences(prefs: PreferenceItem[]): Promise<void> {
  return apiFetch<void>(
    '/api/user-preferences/me',
    {
      method: 'PATCH',
      body: JSON.stringify(prefs),
    },
    API_ROOT_URL,
  );
}

export async function deleteMe(): Promise<void> {
  return apiFetch<void>('/api/users/me', { method: 'DELETE' }, API_ROOT_URL);
}

export async function acceptTerms(): Promise<void> {
  return apiFetch<void>(
    '/api/users/accept-terms',
    { method: 'PATCH', body: JSON.stringify({ hasAgreedWithTerms: true }) },
    API_ROOT_URL,
  );
}
